module.exports = __webpack_public_path__ + "static/media/pdf_download.9da66fba.png";